import { render } from "./PlansComponent.vue?vue&type=template&id=3712d149&scoped=true"
import script from "./PlansComponent.vue?vue&type=script&lang=js"
export * from "./PlansComponent.vue?vue&type=script&lang=js"

import "./PlansComponent.vue?vue&type=style&index=0&id=3712d149&scoped=true&lang=css"

import exportComponent from "/home/runner/work/hanlin-lesson-plan/hanlin-lesson-plan/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3712d149"]])

export default __exports__